<h3>Choose A Folder</h3>

<div class="cell text-center" *ngIf="isLoadingFolders">
  <img width="30" src="/assets/images/loading.gif" alt="Loading" />
  Loading folders...
</div>

<ng-container *ngIf="!isLoadingFolders">
  <div *ngIf="folders && folders.length === 0 && !isFetchingRootFolders && !errorFetchingFolders">
    <div class="margin-top-1">Please create a folder in your {{ currentConnection.name }} account first.</div>
    <button
      data-cy="folder-go-back"
      type="button"
      class="button primary margin-top-1"
      (click)="navigateBackToConnectionPage()"
    >
      Close
    </button>
  </div>

  <div *ngIf="errorFetchingFolders && !isFetchingRootFolders">
    <div class="margin-top-1">There was an error when fetching folders of {{ currentConnection.name }}.</div>
    <div
      class="alert callout margin-top-1"
      data-cy="fetching-folders-error-message"
      *ngIf="errorFetchingFoldersMessage"
    >
      <i class="fa fa-exclamation-triangle"></i>
      {{ errorFetchingFoldersMessage }}
    </div>
    <button
      data-cy="folder-go-back"
      type="button"
      class="button primary margin-top-1"
      (click)="navigateBackToConnectionPage()"
    >
      Close
    </button>
  </div>

  <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="tree connection__tree">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
      <li
        data-cy="tree-node"
        class="mat-tree-node"
        (click)="selectFolderNode(node)"
        [class.is-active]="selectedNodeId === node.id || currentConnection.folder_id === node.id"
      >
        <div class="grid-x">
          <rav-icon [name]="RavIcon.Folder" class="tree__folder-icon primary-color"></rav-icon>
          <span>{{ getNodeName(node) }}</span>
        </div>
      </li>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild()">
      <li data-cy="tree-nested-node">
        <div
          class="mat-tree-node"
          (click)="selectFolderNode(node)"
          [class.is-active]="selectedNodeId === node.id || currentConnection.folder_id === node.id"
        >
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + getNodeName(node)">
            <i
              class="primary-color fa fa-2x"
              *ngIf="!loadingFolderIds.includes(node.id) && node.type !== 'section'"
              [ngClass]="nestedTreeControl.isExpanded(node) ? 'fa-caret-down' : 'fa-caret-right'"
            ></i>
            <img
              *ngIf="loadingFolderIds.includes(node.id)"
              width="20"
              src="/assets/images/loading.gif"
              alt="Loading spinner"
            />
          </button>
          <rav-icon [name]="RavIcon.Folder" class="tree__folder-icon primary-color"></rav-icon>
          <span>{{ getNodeName(node) }}</span>
        </div>
        <ul [class.tree--invisible]="!nestedTreeControl.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
          <div *ngIf="node.oneDriveSkipToken" class="grid-x">
            <div class="cell text-center">
              <div *ngIf="loadingFolderIds.includes(node.id)">
                <img width="30" src="/assets/images/loading.gif" alt="Loading spinner" />
                Loading folders...
              </div>

              <button
                *ngIf="!loadingFolderIds.includes(node.id)"
                (click)="getChildrenFolders(node)"
                class="button tiny hollow"
              >
                Load More Folders
              </button>
            </div>
          </div>
        </ul>
      </li>
    </mat-nested-tree-node>
  </mat-tree>

  <div class="grid-x">
    <div class="cell text-center">
      <div *ngIf="isFetchingRootFolders">
        <img width="30" src="/assets/images/loading.gif" alt="Loading spinner" />
        Loading folders...
      </div>
      <button
        *ngIf="oneDriveSkipTokenForRootFolder && !isFetchingRootFolders"
        (click)="getRootFolders()"
        class="button tiny hollow"
      >
        Load More Folders
      </button>
    </div>
  </div>

  <div
    class="row"
    *ngIf="
      selectedNodeId &&
      ((currentConnection.service === 'onenote' && selectedNodeType === 'notebook') ||
        (currentConnection.service === 'neat' && selectedNodeType === 'Cabinet'))
    "
  >
    <span class="alert-color"
      >{{ currentConnection.service === 'onenote' ? 'Notebook' : 'Cabinet' }} folder selection required. <br />
      Please select a folder under a {{ currentConnection.service === 'onenote' ? 'Notebook' : 'Cabinet' }}.</span
    >
  </div>
  <button
    *ngIf="selectedNodeId"
    data-cy="folder-continue"
    type="button"
    class="button primary margin-top-1"
    (click)="selectFolder(selectedNodeId)"
    [disabled]="
      (currentConnection.service === 'onenote' && selectedNodeType === 'notebook') ||
      (currentConnection.service === 'neat' && selectedNodeType === 'Cabinet')
    "
  >
    Select
  </button>
</ng-container>
